module.exports = __webpack_public_path__ + "img/INPRG.580bb691.svg";